// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + {"65":"f4cc4a8f","343":"d7fc827c","417":"04cfaf9a","467":"39d65fce","599":"ddba65fa"}[chunkId] + ".min.css";
};